export const getModeFromArray = a =>
    Object.values(
        a.reduce((count, e) => {
            if (!(e in count)) {
                count[e] = [0, e]
            }

            count[e][0]++
            return count
        }, {})
    ).reduce((a, v) => (v[0] < a[0] ? a : v), [0, null])[1]

export const getTopicName = topic => {
    if (topic.aiName) return topic.aiName
    const topThreeWords = topic.nodes.slice(0, 3).map(node => node.name)
    return topThreeWords.join(' ')
}

export const extractSortValue = tag => {
    if (!tag) return ''
    // Extract prefix (before colon or before first number)
    const prefixMatch = tag.match(/^(.*?)(:|\s*\d|\s*below|\s*above|$)/i)
    const prefix = prefixMatch ? prefixMatch[1].trim().toLowerCase() : ''

    // Handle "below"
    if (tag.includes('below')) {
        const match = tag.match(/below\s+(\d+)/)
        return prefix + (match ? '000000' : '999999')
    }
    // Handle "above"
    if (tag.includes('above')) {
        const match = tag.match(/above\s+(\d+)/)
        return prefix + (match ? '999999' : '999999')
    }
    // Handle range
    const match = tag.match(/(\d+)\s+to\s+(\d+)/)
    if (match) {
        // Pad number to 6 digits for correct string comparison
        return prefix + String(match[1]).padStart(6, '0')
    }
    // Handle single number (e.g. 'Clicks: 5')
    const singleNumberMatch = tag.match(/(\d+)/)
    if (singleNumberMatch) {
        return prefix + String(singleNumberMatch[1]).padStart(6, '0')
    }
    return prefix + '999999'
}
